<template>
  <accordion
    v-if="canSeeAccordion"
    :title="title ? title : $t(`Filter by ${itemName}`)"
    :icon="icon"
    :active="componentList.length > 0"
    :start-open="visible ? visible : false"
    classes="filter-accordion small mb-3"
  >
    <template slot="accordion-body">
      <div v-if="componentList.length !== 0" class="filters-active">
        <span>{{ 'Active filters' | translate }}</span>
        <b-button
          variant="outline-primary"
          class="btn-sm"
          @click.prevent="cleanComponentFilters()"
        >
          <i class="fas fa-times" /> {{ 'Reset filter' | translate }}
        </b-button>
      </div>
      <b-alert class="alert-primary" v-for="row in componentList" :key="row.id" variant="filter" show>
        <span>{{ row.label | truncate(35) }}</span>
        <span class="close" @mousedown.prevent.stop="removeFilter(row)">
          <i class="fas fa-times" :title="'Delete' | translate" />
        </span>
      </b-alert>
      <multiselect-thux
        label="label"
        attributetype="common filter select"
        :value="componentList[0]"
        :options="listOptions"
        :placeholder="$t('Select an option')"
        :show-clean-button="false"
        @select="addFilter"
      >
        <template v-if="customizeOption" slot="option" slot-scope="data">
          <div class="custom-option" v-html="getCustomOption(data)"></div>
        </template>
      </multiselect-thux>
    </template>
  </accordion>
</template>

<script>

import ThuxGenericComponentFilterMixin from '../../../components/thux-list/ThuxGenericComponentFilterMixin'

export default {
  name: 'StatusListFilter',
  mixins: [ThuxGenericComponentFilterMixin],
  // Quando `defaultStatus` è valorizzato (es. 1 = ENABLED) il filtro mostra
  // l'opzione preselezionata: serve a rendere visibile nella sidebar il fatto
  // che la lista nasconde di default i record disabilitati (status=0).
  props: {
    defaultStatus: { type: Number, default: null }
  },
  data () {
    return {
      icon: 'far fa-circle',
      itemName: 'status'
    }
  },
  computed: {
    listOptions () {
      return [
        { id: 1, label: this.$t('ENABLED'), status: 1 },
        { id: 0, label: this.$t('DISABLED'), status: 1 }
      ]
    }
  },
  watch: {
    // Il "Reset all filters" azzera il componentList (mixin): ri-applichiamo
    // la preselezione di default così la sidebar resta coerente con la lista.
    reset () {
      this.applyDefaultStatus()
    }
  },
  methods: {
    getComponentFilter () {
      this.applyDefaultStatus()
    },
    applyDefaultStatus () {
      if (this.defaultStatus === null || this.defaultStatus === undefined) {
        return
      }
      const option = this.listOptions.find((item) => item.id === this.defaultStatus)
      this.$set(this, 'componentList', option ? [option] : [])
    },
    addFilter (item) {
      const componentList = []
      componentList.push(item)
      this.$set(this, 'componentList', componentList)
      this.$emit('edit', [item.id])
    }
  }
}
</script>
